interface Post {
  id: number;
  title: string;
  date: string;
  category: string[];
  excerpt: string;
  url: string;
  tags: string[];
  thumbnail: string;
}

export class W3Blog {
  private posts: Post[];
  private visiblePostsCount: number;
  private postsContainer: HTMLElement | null;
  private loadMoreButton: HTMLElement | null;
  private categoryFilter: HTMLSelectElement;
  private sortingFilter: HTMLSelectElement;
  private currentPage: number;
  private ajaxUrl: string;
  private postsPerPage: number;
  private loader: HTMLElement | null;
  private loaderBackground: HTMLElement | null;

  constructor() {
    if (typeof window["W3BlogData"] !== "undefined") {
      this.posts = window["W3BlogData"].initial_posts;
      this.ajaxUrl = window["W3BlogData"].ajax_url;
      this.postsPerPage = window["W3BlogData"].posts_per_page;
    } else {
      return;
    }
    this.visiblePostsCount = 9;
    this.currentPage = 1;
    this.postsContainer = document.querySelector(".blog__grid");
    this.loadMoreButton = document.getElementById("blog__load-more--js");
    this.categoryFilter = document.getElementById(
      "category",
    ) as HTMLSelectElement;
    this.sortingFilter = document.getElementById(
      "sorting",
    ) as HTMLSelectElement;
    this.loader = document.querySelector(".loader");
    this.loaderBackground = document.querySelector(".loader-background");

    this.registerEvents();
  }

  private registerEvents() {
    this.categoryFilter.addEventListener("change", () => this.filterPosts());
    this.sortingFilter.addEventListener("change", () => this.filterPosts());
    this.loadMoreButton.addEventListener("click", () => this.loadMorePosts());
  }

  private filterPosts() {
    this.currentPage = 1;
    this.loadPosts(true);
  }

  private loadMorePosts() {
    this.currentPage++;
    this.loadPosts();
  }

  private loadPosts(reset: boolean = false) {
    const selectedCategory = this.categoryFilter.value;
    const selectedSorting = this.sortingFilter.value;

    const data = new FormData();
    data.append("action", "load_more_posts");
    data.append("page", this.currentPage.toString());
    data.append("category", selectedCategory);
    data.append("orderby", selectedSorting);

    this.loader?.classList.toggle("active", true);
    this.loaderBackground?.classList.toggle("active", true);

    fetch(this.ajaxUrl, {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          if (reset) {
            this.postsContainer.innerHTML = "";
            this.posts = response.data;
          } else {
            this.posts = this.posts.concat(response.data);
          }
          this.renderPosts(response.data);

          if (response.data.length < this.postsPerPage) {
            this.loadMoreButton.style.display = "none";
          } else {
            this.loadMoreButton.style.display = "flex";
          }
          setTimeout(() => {
            this.loader?.classList.toggle("active", false);
            this.loaderBackground?.classList.toggle("active", false);
          }, 750);
        } else {
          this.loadMoreButton.style.display = "none";
          setTimeout(() => {
            this.loader?.classList.toggle("active", false);
            this.loaderBackground?.classList.toggle("active", false);
          }, 750);
        }
      });
  }

  private renderPosts(posts: Post[]) {
    if (posts === undefined || posts.length === 0) {
      return;
    }

    posts.forEach((post) => {
      const postElement = document.createElement("a");
      postElement.className = "blog-card";
      postElement.href = post.url;
      postElement.innerHTML = `
        <div class="blog-card__image">
          <img src="${post.thumbnail}" alt="${post.title}">
        </div>
        <div class="blog-card__content">
          <div class="blog-card__category">
            ${post.category}
          </div>
          <div class="blog-card__title h5">${post.title}</div>
          <div class="blog-card__excerpt p-copy">${post.excerpt}</div>
          <div class="blog-card__meta">
            <span class="blog-card__date p-small">${post.date}</span>
            <div class="read-more blog-card__button button button-secondary">
              <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <g>
                  <path d='M5 12H19M19 12L13 18M19 12L13 6' stroke-width='1.25' stroke-linecap='square' stroke-linejoin='round'/>
                </g>
              </svg>
              <svg class='left' width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <g>
                  <path d='M5 12H19M19 12L13 18M19 12L13 6' stroke-width='1.25' stroke-linecap='square' stroke-linejoin='round'/>
                </g>
              </svg>
            </div>
          </div>
        </div>
      `;
      this.postsContainer.appendChild(postElement);
    });
  }
}
